import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// https://developers.google.com/analytics/devguides/collection/ga4/reference/events#login
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackLoginParameters extends TrackEventBaseParameters {}

const trackLogin = (parameters: TrackLoginParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.event({ action: "login", ...parameters }, options);
};

export default trackLogin;
